import React from 'react';

/** Official Town icon (the B set in a landscape), gold on transparent. */
const ICON_SRC = 'https://town.bonnyville.ab.ca/wp-content/uploads/2024/06/Bonnyville_Icon_Gold_RGB.png';
/** Horizontal gold-and-white signature, for the dark grounds. */
const LIGHT_SRC = 'https://town.bonnyville.ab.ca/wp-content/uploads/2024/06/Logo-Yellow-and-White.png';
interface LogoProps {
  className?: string;
  variant?: 'color' | 'light' | 'icon';
}
export function Logo({
  className = '',
  variant = 'color'
}: LogoProps) {
  if (variant === 'icon') {
    return <span className={`inline-flex items-center ${className}`} data-id="element-1329" data-mp="rpuwsijgt65z">
        <img src={ICON_SRC} width={438} height={490} alt="Town of Bonnyville" className="h-[42px] w-auto shrink-0" data-id="element-1330" data-mp="dr4rifmhs06j" />
      </span>;
  }
  if (variant === 'light') {
    return <span className={`inline-flex items-center ${className}`} data-id="element-1331" data-mp="2ykrobay1e7hj">
        <img src={LIGHT_SRC} width={694} height={192} alt="Town of Bonnyville" className="h-[52px] w-auto shrink-0" data-id="element-1332" data-mp="32ks16r5hmamh" />
      </span>;
  }
  return <span className={`inline-flex items-center gap-2.5 ${className}`} data-id="element-1333" data-mp="19xhpdtqrgzjw">
      <img src={ICON_SRC} width={438} height={490} alt="" aria-hidden="true" className="h-[46px] w-auto shrink-0" data-id="element-1334" data-mp="1nvy3w6uv7ucl" />
      <span className="flex flex-col leading-none" data-id="element-1335" data-mp="1xtm256rojjzi">
        <span className="font-display text-[21px] font-extrabold tracking-tight text-ville-navy" data-id="element-1336" data-mp="1xsb0bchsomb1">Bonnyville</span>
        <span className="mt-1 text-[10px] font-bold uppercase tracking-[0.18em] text-ville-blue" data-id="element-1337" data-mp="1suiy9pnfrjt4">
          North of Expected
        </span>
        <span className="sr-only" data-id="element-1338" data-mp="22k2fkqvi35lv">Town of Bonnyville</span>
      </span>
    </span>;
}